import React from 'react'
import { UserOutlined, SettingOutlined, LogoutOutlined, CrownOutlined } from '@ant-design/icons'
import { UserStore } from '@/store/user'
import { Divider } from 'antd'
import { observer } from 'mobx-react-lite'
import { formatDate } from 'date-fns'
const ORANGE_ICON = '/orange.webp'

// 未登录用户的Popover内容
export const UnLoginPopoverContent = ({ handleLogin }: { handleLogin: () => void }) => {
  return (
    <div className="unlogin-popover-content">
      {/* 主标题区域 */}
      <div className="header">
        <div className="title">
          解锁创作潜能
        </div>
        <div className="subtitle">
          登录享受专属权益
        </div>
      </div>
      
      {/* 权益列表 */}
      <div className="benefits">
        <div className="benefits-card">
          {[
            { icon: '💾', text: '无限制保存作品' },
            { icon: '☁️', text: '云端同步设计' },
            { icon: '🎨', text: '专属模板库' },
            { icon: '📸', text: '高清导出无水印' }
          ].map((item, index) => (
            <div key={index} className="benefit-item">
              <span className="icon">{item.icon}</span>
              <span>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
      
      {/* 自定义登录按钮 */}
      <button 
        className="login-button"
        onClick={handleLogin}
      >
        立即登录，开启创作之旅
      </button>
      
      {/* 底部提示 */}
      <div className="footer-tip">
        免费注册 · 30秒即可开始
      </div>
    </div>
  )
}

// 已登录用户的Popover内容
export const LoginPopoverContent = observer(({ 
  user, 
  onSetting, 
  onLogout,
  onUpgrade
}: { 
  user: UserStore
  onSetting: () => void
  onLogout: () => void 
  onUpgrade?: () => void
}) => {
  const isVip = user?.vipLevel > 0

  return (
    <div className="login-popover-content">
      {/* 用户信息区域 */}
      <div className="user-info">
        <div className="user-avatar">
          {user.avatar ? (
            <img src={user.avatar} alt="avatar" className="avatar-img" />
          ) : (
            <div className="avatar-placeholder">
              <UserOutlined />
            </div>
          )}
        </div>
        <div className="user-details">
          <div className="username">
            {user.nickname || user.userName || '用户'}
          </div>
          <div className="user-status">
            {isVip ? (
              <div className="vip-status">
                <CrownOutlined className="vip-icon" />
                <span className="vip-text">VIP会员</span>
                {user.vipExpiresAt > 0 && (
                  <p className="vip-expires">
                    {formatDate(Number(user.vipExpiresAt), 'yyyy-MM-dd')}
                  </p>
                )}
                <span className='vip-renew' onClick={onUpgrade}>续费</span>
              </div>
            ) : (
              <span className="normal-status">普通用户</span>
            )}
          </div>
        </div>
        <div className="setting-button" onClick={onSetting}>
          <SettingOutlined className="setting-icon" />
        </div>
      </div>

      {/* VIP会员开通区域 */}
      {!isVip && (
        <>
          <div className="divider"></div>
          <div className="vip-promotion">
            <div className="vip-header">
              <div className="vip-title">
                开通会员畅享全站设计资源和工具
              </div>
              <div className="vip-subtitle">
                商用版权无忧
              </div>
            </div>
            <button className="upgrade-button"  onClick={onUpgrade}>
              <CrownOutlined className="crown-icon" />
              开通会员
            </button>
          </div>
        </>
      )}

      <Divider style={{ margin: '12px 0' }} />

      {/* 橙豆积分区域 */}
      <div className="points-section">
        <div className="points-item">
          <span className="points-icon">
            <img src={ORANGE_ICON} alt="orange" style={{ width: 14, height: 14 }} />
          </span>
          <span className="points-label">橙豆</span>
          <span className="points-value">{user?.points > 0 ? user.points : '0'}</span>
        </div>
      </div>

      <Divider style={{ margin: '12px 0' }} />

      {/* Footer区域 */}
      <div className="logout-container">
        <div className="logout" onClick={onLogout}>
          <LogoutOutlined/>
          <span>退出登录</span>
        </div>
      </div>
    </div>
  )
})